var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaundary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "inline"
    },
    height: "1.5em",
    viewBox: "0 -960 960 960",
    width: "1.5em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240-387v-134l-75 41L45-688l264-152h51q16 46 42.67 83 26.66 37 77.33 37 51.33 0 78-37t42-83h51l263 153-119 207-75-41v208l-61 52.33q-6.33 6-16 10.17t-18 4.17q-7.33 0-15.33-3t-14-8.34L483-354q-31.33-26.67-70-40-38.67-13.33-78.33-13.33-24.67 0-48.17 5.16Q263-397 240-387Zm-53.33 199.33-43.34-51L225-308q23-19.33 51.5-29.5 28.5-10.17 58.5-10.17t58 10.17q28 10.17 51 29.5l116 99q13.33 11.33 30.5 16.83 17.17 5.5 35.5 5.5 18 0 35.17-5.66 17.16-5.67 30.5-16.67l81.66-71 43.34 52L735-158.67q-23 19.34-51 29-28 9.67-58 9.67t-58.5-9.67q-28.5-9.66-51.5-29l-115.33-99q-13.34-11.33-30.5-16.83Q353-280 335-280q-18.33 0-35.5 5.5T269-257.67l-82.33 70Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundary);
export default __webpack_public_path__ + "static/media/laundary.bf4eca054b3b70dffc48fbe89d9c5ce6.svg";
export { ForwardRef as ReactComponent };